// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__DVd6l","title":"style_title__1UIrh","content":"style_content__f_DMP","spacer":"style_spacer__U3Bag"};